import { orchestrator } from 'satcheljs';
import { openTimeStreamProject, setPoliteAnnouncement } from 'owa-timestream-store';
import isCanvasLockEnabled from '../selectors/isCanvasLockEnabled';
import isCanvasLocked from '../selectors/isCanvasLocked';
import loc from 'owa-localize';
import {
    canvasUnlockedAnnouncement,
    canvasLockedAnnouncement,
} from './CanvasLockAnnouncements.locstring.json';

orchestrator(openTimeStreamProject, () => {
    if (isCanvasLockEnabled()) {
        setPoliteAnnouncement(
            isCanvasLocked() ? loc(canvasLockedAnnouncement) : loc(canvasUnlockedAnnouncement)
        );
    }
});
